// actions.js
import {
  FETCH_RELEASE_NOTES_REQUEST,
  FETCH_RELEASE_NOTES_SUCCESS,
  FETCH_RELEASE_NOTES_FAILURE,
  OPEN_EDIT_RELEASE_NOTE_PAGE,
  OPEN_EDIT_RELEASE_NOTE_PAGE_SUCCESS,
  DELETE_RELEASE_NOTES_REQUEST,
  DELETE_RELEASE_NOTES_FAILURE,
  DELETE_RELEASE_NOTES_SUCCESS,
  FETCH_RELEASE_NOTE_REQUEST,
  FETCH_RELEASE_NOTE_SUCCESS,
  FETCH_RELEASE_NOTE_FAILURE,
  UPDATE_RELEASE_NOTES_REQUEST,
  UPDATE_RELEASE_NOTES_SUCCESS,
  UPDATE_RELEASE_NOTES_FAILURE,
  CLEAR_RELEASE_NOTE_ERRORS,
  CLEAR_RELEASE_NOTE_SUCCESS
} from './actionTypes';

export const fetchReleaseNotesRequest = () => ({
  type: FETCH_RELEASE_NOTES_REQUEST,
});

export const fetchReleaseNotesSuccess = (releaseNotes) => ({
  type: FETCH_RELEASE_NOTES_SUCCESS,
  payload: releaseNotes,
});

export const fetchReleaseNotesFailure = (error) => ({
  type: FETCH_RELEASE_NOTES_FAILURE,
  payload: error,
});

export const fetchReleaseNoteRequest = (id) => ({
  type: FETCH_RELEASE_NOTE_REQUEST,
  payload: id
});

export const fetchReleaseNoteSuccess = (releaseNote) => ({
  type: FETCH_RELEASE_NOTE_SUCCESS,
  payload: releaseNote,
});

export const fetchReleaseNoteFailure = (error) => ({
  type: FETCH_RELEASE_NOTE_FAILURE,
  payload: error,
});

export const updateReleaseNoteRequest = (releaseNote, navigate) => ({
  type: UPDATE_RELEASE_NOTES_REQUEST,
  payload: { releaseNote, navigate }
});

export const updateReleaseNoteSuccess = () => ({
  type: UPDATE_RELEASE_NOTES_SUCCESS,
});

export const updateReleaseNoteFailure = (error) => ({
  type: UPDATE_RELEASE_NOTES_FAILURE,
  payload: error,
});

export const deleteReleaseNoteRequest = (id) => ({
  type: DELETE_RELEASE_NOTES_REQUEST,
  payload: id
});

export const deleteReleaseNoteSuccess = (id) => ({
  type: DELETE_RELEASE_NOTES_SUCCESS,
  payload: id,
});

export const deleteReleaseNoteFailure = (error) => ({
  type: DELETE_RELEASE_NOTES_FAILURE,
  payload: error,
});

export const openEditReleaseNotePage = (id, navigate) => ({
  type: OPEN_EDIT_RELEASE_NOTE_PAGE,
  payload: { id, navigate }
});

export const openEditReleaseNotePageSuccess = () => ({
  type: OPEN_EDIT_RELEASE_NOTE_PAGE_SUCCESS,
});

export const clearReleaseNoteErrors = () => ({
  type: CLEAR_RELEASE_NOTE_ERRORS,
});

export const clearReleaseNoteSuccess = () => ({
  type: CLEAR_RELEASE_NOTE_SUCCESS,
});